import { render, staticRenderFns } from "./SourcePageDesktop.vue?vue&type=template&id=9f646e2e&scoped=true&"
import script from "./SourcePageDesktop.vue?vue&type=script&lang=js&"
export * from "./SourcePageDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SourcePageDesktop.vue?vue&type=style&index=0&id=9f646e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f646e2e",
  null
  
)

export default component.exports